import { useNavigate } from 'react-router';

import fail from '../../../assets/images/failIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function FailPopup() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClosePopup = () => {
    dispatch(closePopup());
    navigate('/');
  };

  return (
    <div className={styles.failPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.failTextWrapper}>
        <img src={fail} alt="иконка красный крестик" />
        <h2 className={styles.failTitle}>Заказ создать не удалось!</h2>
        <h3 className={styles.failSubTitle}>
          Не удалось создать заказ на сдачу вещей на хранение
        </h3>
        <p className={styles.failText}>Попробуйте создать заказ позже</p>
      </div>
      <RedButton text="Продолжить" onClick={handleClosePopup} width={308} height={54} />
    </div>
  );
}

export default FailPopup;
